import {api} from '../../contexts/AuthContext';
import {
    StrategySimulationCreateBody,
    StrategySimulationCreateResponse
} from '../../types';

export const strategySimulationApi = {
    create: async (
        promptId: string,
        body: StrategySimulationCreateBody
    ): Promise<StrategySimulationCreateResponse> => {
        const response = await api.post(
            `/api/prompts/${promptId}/strategy-simulations`,
            body
        );
        return response.data;
    },
};
